import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-accent mb-4 text-xs font-medium"
}
const _hoisted_2 = { class: "space-y-6" }
const _hoisted_3 = { class: "grid gap-2" }
const _hoisted_4 = { class: "text-muted-foreground space-x-1 text-center text-xs" }

import InputError from '@/components/InputError.vue';
    import TextLink from '@/components/TextLink.vue';
    import { Button } from '@/components/ui/button';
    import { Input } from '@/components/ui/input';
    import { Label } from '@/components/ui/label';
    import AuthLayout from '@/layouts/AuthLayout.vue';
    import { Head, useForm } from '@inertiajs/vue3';
    import { LoaderCircle } from 'lucide-vue-next';
    import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ForgotPassword',
  props: {
    status: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    

    const form = useForm({
        email: '',
    });

    const submit = () => {
        form.post(route('password.email'));
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AuthLayout, {
    title: _unref(t)('auth.forgot_password'),
    description: _unref(t)('auth.enter_email_to_receive_password_reset_link')
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Head), {
        title: _unref(t)('auth.forgot_password')
      }, null, 8, ["title"]),
      (_ctx.status)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.status), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(submit, ["prevent"]),
          class: "flex flex-col gap-4"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Input), {
              id: "email",
              type: "email",
              name: "email",
              autocomplete: "off",
              modelValue: _unref(form).email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).email) = $event)),
              autofocus: "",
              placeholder: _unref(t)('auth.email_placeholder'),
              class: "placeholder:text-foreground/80"
            }, null, 8, ["modelValue", "placeholder"]),
            _createVNode(InputError, {
              message: _unref(form).errors.email
            }, null, 8, ["message"])
          ]),
          _createVNode(_unref(Button), {
            width: "full",
            disabled: _unref(form).processing,
            loading: _unref(form).processing
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('auth.email_password_reset_link')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ], 32),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('auth.or_return_to')), 1),
          _createVNode(TextLink, {
            href: _ctx.route('login')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('auth.log_in')), 1)
            ]),
            _: 1
          }, 8, ["href"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "description"]))
}
}

})